<script>
  import { onMount } from "svelte";
  import {External, M} from "../external";

  let introVideoMarkup = "";
  let shareUrl = "https://" + External.primaryDomain;

  let copy = () => {
    External.Tools.copyToClipboard(shareUrl);
    External.Tools.showCornerMessage(1000, M.COPIED_TO_CLIPBOARD, External.Tools.TOOLTIP_TYPE_SUCCESS);
  };
  onMount(() => {
    if (External.Website.onboarding && External.Website.onboarding.storeDashboard) {
      introVideoMarkup = External.CPanel.getEmbedVideo(External.Website.onboarding.storeDashboard);
    }
  });
</script>

<div class="account-settings store-products">
  <div class="inner-wrapper members-table-wrapper">
    <div class="top-background-wrapper narrow-top-background dash-top-background" style="padding-top: 15px;">
      <div class="top-background">
        <div class="text-wrapper flex align-center none">
          <h1 class="members-title f-left t-center" style="margin-bottom: 0;">{M.STORE_DASHBOARD}</h1>
        </div>
      </div>
    </div>

    <div class="content-wrapper members-content-wrapper">
      <div class="sections-wrapper profile-inner-wrapper bg-white box-shadow" style="margin-bottom: 60px;">
        <div class="col20 f-left getting-started-layout getting-started-layout-big flex flex-col v2">
          <div class="col20 f-left flex flex-row flex-col-mobile justify-center mb-25">
            <div class="col11 f-left flex justify-center flex-col">
              <h4 class="col20 f-left"><span>{M.GETTING_STARTED}</span></h4>
              <h1 class="col20 f-left mt-10 mb-15">{M.SETUP_YOUR_STORE}</h1>
              <span class="col20 f-left paragraph-text">{M.SETP_YOUR_STORE_DESC}</span>
              <div class="col20 f-left mt-25">
                {@html introVideoMarkup}
              </div>
            </div>
            <div class="col9 f-left justify-center align-center flex">
              <div class="col20 f-left justify-center align-center flex flex-col store-getting-started">
                <div class="col20 f-left gray-section product-select-wrapper">
                  <div class="col20 f-left ab-step center-vertically">
                    <div class="small-circle-icon"><span class="material-icons-outlined"> add_business </span></div>
                    <div>
                      <h4 class="roboto">{M.CREATE_A_PRODUCT}</h4>
                      <span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE}</span>
                    </div>
                    <a class="text-link blue-text" rel="tab" href="/me/store/products/">{M.CREATE}</a>
                  </div>
                </div>
                <div class="col20 f-left gray-section product-select-wrapper">
                  <div class="col20 f-left ab-step center-vertically">
                    <div class="small-circle-icon"><span class="material-icons-outlined"> credit_card </span></div>
                    <div>
                      <h4 class="roboto">{M.CONNECT_PROCESSOR}</h4>
                      <span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE}</span>
                    </div>
                    <a class="text-link blue-text" rel="tab" href="/me/store/settings#payments">{M.CONNECT}</a>
                  </div>
                </div>
                <div class="col20 f-left gray-section product-select-wrapper">
                  <div class="col20 f-left ab-step center-vertically">
                    <div class="small-circle-icon"><span class="material-icons-outlined"> store </span></div>
                    <div>
                      <h4 class="roboto">{M.ADD_STORE_DETAILS}</h4>
                      <span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE}</span>
                    </div>
                    <a class="text-link blue-text" rel="tab" href="/me/store/settings">{M.ADD}</a>
                  </div>
                </div>
                <div class="col20 f-left gray-section product-select-wrapper">
                  <div class="col20 f-left ab-step center-vertically">
                    <div class="small-circle-icon"><span class="material-icons-outlined"> local_shipping </span></div>
                    <div>
                      <h4 class="roboto">{M.SHIPPING_METHOD_PHYSICAL}</h4>
                      <span class="light-gray-text mt-5 ml-0">{M.SMALL_PERIOD_EXAMPLE_2}</span>
                    </div>
                    <a class="text-link blue-text" rel="tab" href="/me/store/settings#shipping">{M.ADD}</a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col20 f-left" style="margin-bottom: 5%;">
          <div class="col20 f-left flex flex-col-mobile flex-row space-between" style="padding: 0 3%; box-sizing: border-box;">
            <div class="col9n f-left gray-section product-select-wrapper vertical-gray-section mb-5">
              <div class="col20 f-left ab-step flex flex-col flex-col-mobile">
                <div class="big-circle-icon f-left flex-none mb-15"><span class="material-icons-outlined"> brush </span></div>
                <div>
                  <h4 class="roboto col20 f-left mb-10">{M.EDIT_DRAG_DROP}<br /></h4>
                  <span class="light-gray-text mt-5 ml-0 display-block col20 f-left">{M.EDIT_DRAG_DROP_DESC}</span>
                  <div class="col20 f-left mt-15">
                    <a class="middle-button blue f-left" rel="tab" href="/me/website">{M.EDIT_PAGES}</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col9n f-right gray-section product-select-wrapper vertical-gray-section mb-5">
              <div class="col20 f-left ab-step flex flex-col flex-col-mobile">
                <div class="big-circle-icon f-left flex-none mb-15"><span class="material-icons-outlined"> storefront </span></div>
                <div>
                  <h4 class="roboto col20 f-left mb-10">{M.SHARE_SELL}</h4>
                  <span class="light-gray-text mt-5 ml-0 display-block col20 f-left">{M.SHARE_SELL_DESC}</span>
                  <div>
                    <div class="col20 f-left affiliate-link-wrapper flex align-center space-between mt-15 mb-15">
                      <div class="flex align-center">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                          <path d="M0 0h24v24H0z" fill="none" /><path
                            d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" /></svg>
                        <h4>{shareUrl} <a on:click={copy} class="copy-affiliate-link flex-none rounded-effect">{M.COPY}</a></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
